import React from 'react';
import styled from 'styled-components';


export default function About() {
 
  return (
    <Container>
        <div className="container">
<div className="title">
  <h1>About Universal Chat</h1>
</div>
      <div className="description">
  
        <p>Universal Chat is a free and secure chat application that allows you to connect with people from all around the world. It provides a seamless messaging experience with advanced features to enhance your communication.</p>
        <div className="points">
        <li>Seamless Communication: Emphasize how your chat app enables users to connect and communicate seamlessly with friends, family, or colleagues.</li>
  <li>Instant Connectivity: Stay connected with your loved ones in real-time, no matter where they are. UniChat ensures instant connectivity at your fingertips.</li>
  <li>Free and Secure: Enjoy the freedom of unlimited messaging without any charges. UniChat prioritizes your privacy and employs robust security measures to keep your conversations safe and confidential.</li>
  <li>User-Friendly Interface: UniChat boasts a user-friendly interface designed to enhance your chat experience. Effortlessly navigate through conversations and access features with ease.</li>
  <li>Multimedia Sharing: Share memorable moments with friends and family through UniChat's multimedia sharing feature. Send photos, videos, and more to make your conversations come alive.</li>
</div>
      </div>
     
      
      <div className='disclaimer'>
       <p>
          Disclaimer: Universal Chat is a personal project and does not store any user data. It is intended for demonstration purposes only.
        </p>
      </div>
        </div>
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  margin-top: 2%;
  
  .container {
    align-items: center;
    text-align:center;
    height: 100%;
    min-height:100vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns:  100%;}
    .disclaimer{
      font-size: 0.8rem;
  color: #fff;
  text-align: center;
    }
    .contactText{
      font-size: 1rem;
      color: #fff;
    }
    .contactItem{
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    .title{
      
      color: #fff;
    }
    .description{
      padding:2rem;
    }
    .description p{
      
      font-size: 1.2rem;
      color: #fff;
      text-align: start;
    }
    .description li{
      text-align: start;
      padding:15px;
      color: #fff;
    }
    .points{
      margin-top:1rem;
      display: grid;
      grid-template-columns: 50% 50%;
      @media screen and (max-width: 480px){
        display: flex;
    flex-direction: column;
      }
    }
  
`;

